import React, { Component } from "react";
import { Toast } from "primereact/toast";

import Server from "./../Server.js";
import { connect } from "react-redux";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";

import Header from "./../Header.js";
import { ProgressSpinner } from "primereact/progressspinner";
import { Sidebar } from "primereact/sidebar";
import { SelectButton } from "primereact/selectbutton";
import { Chip } from "primereact/chip";
import { Tag } from "primereact/tag";
import LoginBox from "./../LoginBox.js";

class TransferLink extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.toast = React.createRef();
    this.state = {
      Shops: [],
      ShopsList: [],
      shopsInWallet: [],
      wallet: "mehr",
      selectedShop: null,
      ButtonText: "انجام عملیات",
      SelectItems: [
        { label: "نقدی", value: "" },
        { label: "کیف پول", value: "credit" },
      ],
      wallets: [],
      serverUrl: this.Server.getAbsoluteUrl(),
      systemId: this.Server.getSystem()
        ? this.Server.getSystem().id
        : props.systemId,
      AppAddress: this.Server.getAppAddress(),
      AppName: this.Server.getAppName()
    };
  }
  convertNum(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];

    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  componentDidMount() {
    if (!this.props.username) {
      this.setState({
        showLogin: true,
      });
    } else {
      this.GetAccounts();
    }
  }
  GetAccounts = () => {
    let SCallBack = (response) => {
      let data = [];
      let resp = [];
      for (let i = 0; i < response.length; i++) {
        resp[i] = response[i].children;
      }
      for (let i = 0; i < resp.length; i++) {
        for (let j = 0; j < resp[i].length; j++) {
          if (resp[i][j].name == "A_Kind") {
            if (resp[i][j].value == "5") data.push(resp[i]);
          }
        }
      }
      let AccList = [];
      for (let i = 0; i < data.length; i++) {
        AccList[i] = {
          value: data[i][1].value,
          label: data[i][3].value + "(" + data[i][1].value + ")",
        };
      }
      this.setState({
        AccList: AccList,
        AccDialog: AccList.length > 1 ? 1 : 0,
        AccountNumber: AccList.length > 1 ? null : AccList[0].value,
        ShowLoading: false,
      });
      this.getUser(1);
    };
    let ECallBack = (error) => {
      this.setState({
        ShowLoading: false,
      });
    };
    var param =
      '{CommandNo : "3" , AccountNo: "' +
      this.props.account +
      '",Param1: "' +
      this.props.password +
      '" }';
    let ip = this.props.ip || this.state.AppAddress;
    this.setState({
      ShowLoading: true,
    });
    this.Server.sendRaymand(
      "" + ip + "/MobileBank.aspx/MobileBankSp",
      param,
      SCallBack,
      ECallBack,
      {
        ip: this.props.ip,
      }
    );
  };
  CreateLink = () => {
    if (!this.state.userMobile) {
      this.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: (
          <div className="iranyekanwebmedium">شماره موبایل را وارد کنید</div>
        ),
        life: 40000,
      });
      return;
    }
    if (!this.state.price) {
      this.toast.current.show({
        severity: "warn",
        summary: <div className="iranyekanwebmedium"></div>,
        detail: <div className="iranyekanwebmedium">مبلغ را وارد کنید</div>,
        life: 40000,
      });
      return;
    }
    this.Server.send(
      "MainApi/SendTransferLink",
      {
        RaymandAcc: this.state.AccountNumber,
        mobile: this.state.userMobile,
        PlaceNumber: this.props.place,
        description: this.state.description || "",
        price: this.state.price.toString().replace(/,/g, ""),
      },
      (response) => {
        this.setState({
          ShowLoading: false,
          text: response.data.result
        });
        this.toast.current.show({
          severity: "success",
          summary: <div className="iranyekanwebmedium"></div>,
          detail: (
            <div className="iranyekanwebmedium">ارسال پیامک انجام شد</div>
          ),
          life: 40000,
        });
      },
      (error) => {
        this.setState({
          ShowLoading: false,
        });
      }
    );
    this.setState({
      ShowLoading: true,
    });
  };
  async shareData(){
    try {
      await navigator.share({
        title: this.state.AppName,
        url: this.state.AppAddress,
        text: this.state.text ,
      });
    } catch (err) {
    }
  }
  render() {
    return (
      <div style={{ height: "100%" }}>
        <Toast
          ref={this.toast}
          position="top-right"
          style={{ fontFamily: "iranyekanwebmedium", textAlign: "right" }}
        />

        <div>
          <Header
            ComponentName="ساخت لینک واریز "
            ComponentLName="app-icon-3"
          />
        </div>

        <div style={{ direction: "rtl", height: "100%" }}>
          {!this.state.ShowLoading ? (
            <div
              className="sarv-bg1 sarv-home-top-box"
              style={{ height: "100%" }}
            >
              <p style={{ textAlign: "center", paddingTop: 20 }}>
                حساب شماره {this.state.AccountNumber}
              </p>

              <div style={{ padding: 20 }}>
                <div floatingLabel>
                  <div
                    style={{ fontFamily: "iranyekanwebmedium", fontSize: 13 }}
                  >
                    موبایل
                  </div>
                  <InputText
                    autocomplete="off"
                    value={this.state.userMobile}
                    name="userMobile"
                    onChange={(event) => {
                      let value = event.target.value;
                      this.setState({ userMobile: value });
                    }}
                    style={{
                      direction: "ltr",
                      fontFamily: "iranyekanwebmedium",
                      width: "100%",
                      fontSize: 18,
                    }}
                  />
                </div>
                <div floatingLabel style={{ marginTop: 10 }}>
                  <div
                    style={{ fontFamily: "iranyekanwebmedium", fontSize: 13 }}
                  >
                    {" "}
                    مبلغ (ریال)
                  </div>
                  <InputText
                    autocomplete="off"
                    value={this.state.price}
                    keyboardType="number-pad"
                    name="price"
                    onChange={(event) => {
                      let value = event.target.value;
                      value = event.target.value
                        .toString()
                        .replace(/,/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                      this.setState({ price: value });
                    }}
                    style={{
                      direction: "ltr",
                      fontFamily: "iranyekanwebmedium",
                      width: "100%",
                      fontSize: 18,
                    }}
                  />
                </div>
                <div floatingLabel style={{ marginTop: 10 }}>
                  <div
                    style={{ fontFamily: "iranyekanwebmedium", fontSize: 13 }}
                  >
                    شرح (اختیاری)
                  </div>
                  <InputText
                    autocomplete="off"
                    value={this.state.description}
                    name="description"
                    onChange={(event) => {
                      let value = event.target.value;
                      this.setState({ description: value });
                    }}
                    style={{
                      textAlign: "center",
                      direction: "ltr",
                      fontFamily: "iranyekanwebmedium",
                      width: "100%",
                      fontSize: 18,
                    }}
                  />
                </div>
                <div style={{ marginTop: 20, textAlign: "center" }}>
                  <Button
                    info
                    rounded
                    onClick={() => this.CreateLink()}
                    disabled={this.state.ShowLoading}
                  >
                    <span
                      style={{
                        fontFamily: "iranyekanwebmedium",
                        fontSize: 15,
                        width: "100%",
                      }}
                    >
                      ساخت لینک و ارسال پیامک
                    </span>
                  </Button>
                </div>
                <div style={{ marginTop: 20, textAlign: "center" }}>
                <Button style={{fontFamily:'iranyekanwebmedium'}} disabled={!this.state.text}  onClick={()=>{
                  this.shareData()
                }}>ارسال به دیگران</Button>
               </div> 

                <p style={{ textAlign: "center", paddingTop: 20 }}>
                  لینک مستقیم پرداخت اینترنتی به حساب فوق ، بلافاصله از طریق
                  پیامک به مشتری ارسال خواهد شد
                </p>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <ProgressSpinner
                style={{ width: "50px", height: "50px" }}
                strokeWidth="2"
                fill="var(--surface-ground)"
                animationDuration=".5s"
              />
            </div>
          )}
        </div>
        <Dialog
          header="انتخاب حساب"
          visible={this.state.AccDialog}
          maximized={true}
          onHide={() => {
            this.setState({
              AccDialog: false,
            });
            window.history.back();
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "60%",
              flexDirection: "column",
            }}
          >
            <div style={{ height: "100px" }}></div>
            {!this.state.AccountNumber && (
              <Dropdown
                style={{ width: "90%", textAlign: "right" }}
                value={this.state.AccountNumber}
                options={this.state.AccList}
                onChange={(e) =>
                  this.setState({ AccountNumber: e.value, AccDialog: false })
                }
                placeholder="حساب خود را انتخاب کنید"
              />
            )}
          </div>
        </Dialog>
        <Dialog
          header="ورود به سامانه"
          visible={this.state.showLogin}
          maximized={true}
          resizable={false}
          draggable={false}
          onHide={() => {
            this.setState({
              showLogin: false,
            });
            window.history.back();
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <LoginBox
              appData={this.props.appData}
              loginBank={true}
              AfterLogin={(variables) => {
                this.GetAccounts();
                this.setState({
                  showLogin: false,
                });
              }}
            />
          </div>
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    LoginAnia: state.LoginAnia,
    appData: state.appData,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
}
export default connect(mapStateToProps)(TransferLink);
